module.exports = __webpack_public_path__ + "img/6408b80a075e4c92882cbabd145fb9a6.svg";